/** Max JSON.parse passes when AppSync double-encodes STRING/JSON sentinels on the wire. */
const MAX_JSON_DECODE_DEPTH = 4;
function looksLikeJsonDocument(text) {
    const trimmed = text.trim();
    if (trimmed === '' || trimmed === 'true' || trimmed === 'false' || trimmed === 'null') {
        return true;
    }
    if (trimmed.startsWith('{') || trimmed.startsWith('[') || trimmed.startsWith('"')) {
        return true;
    }
    return /^-?\d/.test(trimmed);
}
/**
 * Decode `FlagEvaluation.value` (evaluate query) and nested push `value` fields from
 * AWSJSON into the semantic runtime value consumer apps read via `getFlagAsync()`.
 *
 * AppSync may leave authored empty STRING (`""`) or JSON (`{}`) sentinels multi-encoded:
 * the evaluate resolver pre-serialises empty strings so `AWSJSON!` is non-null, and the
 * transport can arrive as the two-character string `"\"` after a single `JSON.parse`.
 * Peel JSON string layers until a non-string scalar or structured value is reached.
 */
export function decodeEvaluatedFlagValue(raw) {
    if (raw === null || raw === undefined) {
        return raw;
    }
    if (typeof raw !== 'string') {
        return raw;
    }
    let current = raw;
    for (let depth = 0; depth < MAX_JSON_DECODE_DEPTH && typeof current === 'string'; depth++) {
        const trimmed = current.trim();
        if (trimmed === '') {
            return '';
        }
        if (!looksLikeJsonDocument(trimmed)) {
            return trimmed;
        }
        try {
            const parsed = JSON.parse(trimmed);
            current = parsed;
            if (typeof parsed !== 'string') {
                return parsed;
            }
        }
        catch {
            return trimmed;
        }
    }
    return current;
}
//# sourceMappingURL=evaluated-flag-value-codec.js.map